export const LANDING_PAGE = "/";

export const HOME_PAGE = "/home";

export const BOOKMARKS_PAGE = "/bookmarks";

export const FINISHED_MODULES_PAGE = "/finished-modules";

export const WELCOME_PAGE = "/welcome";

export const SIGNUP_PAGE = "/signup";

export const SIGNUP_APPROVED_PAGE = "/signup/approved";

export const SIGNUP_PENDING_PAGE = "/signup/pending";

export const CREATE_MODULE_PAGE = "/create-module";

export const CREATE_ENTITY_PAGE = "/entity/create";

export const UPDATE_ENTITY_PAGE = "/entity/update";

export const HOOKS_PAGE = "/hooks";

export const CREATE_PASSWORD_PAGE = "/create-password";

export const CHANGE_PASSWORD_PAGE = "/change-password";

export const NOT_AUTHORIZED_PAGE = "/not-authorized";

export const MY_ACCOUNT_PAGE = "/account";

export const MANAGE_USERS_PAGE = "/manage-users";

export const MAKE_HELP_REQUEST_PAGE = "/ask-for-help";

export const VIEW_HELP_REQUESTS_PAGE = "/help-requests";

export const FORGOT_PASSWORD_PAGE = "/forgot-password";

export const COURSE_PAGE = "/course";

export const UPLOAD_THUMBNAIL = "/module-thumbnail";

export const LESSON_UPLOAD = "/lesson-upload";

export const VIEW_PAGE = "/view-page";

export const FEEDBACK_PAGE = "/feedback";
